"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Interrupters = void 0;
require("./Interrupters.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
var _renderObject = require("../../util/renderObject/renderObject");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Card = _interopRequireDefault(require("../Card/Card"));
var _couponUtil = require("./util/couponUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Represents a Interrupters component
 *
 * @method
 * @param {InterruptersProps} props
 * @returns Interrupters
 */

const Interrupters = props => {
  const {
    actionGroups,
    backgroundColor = defaultProps.backgroundColor,
    bodyCopy,
    cardAccessibilityLabel,
    couponDetails,
    externalAction,
    externalCouponAction,
    externalMedia,
    headline,
    headlineTag = defaultProps.headlineTag,
    image,
    theme = defaultProps.theme,
    variant = defaultProps.variant
  } = props;
  const [couponLabel, setCouponLabel] = (0, _react.useState)(couponDetails?.couponLabel);
  const [couponIcon, setCouponIcon] = (0, _react.useState)('copy');
  const [couponContainerTitle, setCouponContainerTitle] = (0, _react.useState)('Copy to Clipboard');
  const componentClassName = (0, _classnames.default)('pal-c-Interrupters', {
    [`pal-c-Interrupters--${variant}`]: variant
  });
  const hasHeaderImage = variant !== 'coupon';
  const hasBodyFooterContent = variant !== 'imageOnly';
  const isDoubleWide = variant === 'doubleWide';
  const isCoupon = variant === 'coupon';
  const handleClick = () => {
    setCouponLabel(couponDetails?.couponAppliedLabel);
    setCouponIcon('check');
    setCouponContainerTitle('Copy to Clipboard Successful');
  };
  (0, _react.useEffect)(() => {
    const timer = (0, _couponUtil.couponUtil)(setCouponLabel, setCouponIcon, setCouponContainerTitle, couponDetails);
    return () => clearTimeout(timer);
  }, [couponLabel]);
  const headerProps = hasHeaderImage ? {
    image,
    externalMedia
  } : undefined;
  const bodyProps = hasBodyFooterContent ? {
    title: {
      text: headline,
      textStyle: 'title-lg',
      tagName: headlineTag
    },
    titleSupport: bodyCopy
  } : undefined;
  const couponDetailsAction = /*#__PURE__*/_react.default.createElement("span", {
    title: couponContainerTitle,
    "aria-live": "assertive",
    role: "status"
  }, externalCouponAction && (0, _renderObject.renderObject)(externalCouponAction), !externalCouponAction && /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "secondary",
    size: "tiny",
    iconName: couponIcon,
    iconPosition: "before",
    label: couponLabel,
    onClick: handleClick
  }));
  const footerProps = isCoupon ? {
    externalAction,
    actionGroups: {
      actions: [{
        coupon: true,
        externalAction1: couponDetailsAction
      }]
    }
  } : hasBodyFooterContent ? {
    externalAction,
    actionGroups
  } : undefined;
  const conditionalProps = (0, _conditionalAttributes.conditionalAttributes)({
    backgroundColor: variant !== 'imageOnly' && !!backgroundColor ? backgroundColor : undefined,
    padding: isCoupon || variant === 'imageOnly' || variant === 'imageCopy' ? undefined : 'sm',
    contentAlign: isDoubleWide ? 'middle' : undefined,
    imgAlign: !isDoubleWide ? 'top' : undefined
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-label": cardAccessibilityLabel,
    className: componentClassName,
    role: "region"
  }, /*#__PURE__*/_react.default.createElement(_Card.default, _extends({
    imgGap: "md",
    contentGap: "md",
    theme: theme
  }, conditionalProps, headerProps, bodyProps, footerProps)));
};

/**
 * Property type definitions
 * @typedef InterruptersProps
 * @type {object}
 * @property {object} actionGroups - actionGroups object
 * @property {string} backgroundColor - string value that sets the background color of the Interrupters content
 * @property {string} bodyCopy - string value that sets the bodyCopy text
 * @property {string} cardAccessibilityLabel - string that sets the aria-label for Interrupters
 * @property {object} couponDetails - couponDetails object
 * @property {object} externalAction - external action object
 * @property {string} cardAccessibilityLabel - string that sets the aria-label for Interrupters
 * @property {string} theme - sets the theme at the component level
 * @property {object} externalCouponAction - external coupon action button object
 * @property {object} externalMedia - external image media object
 * @property {string} headline - string value that sets the headline text
 * @property {string} headlineTag - string value that sets the HTML heading level tag
 * @property {string} variant - string value that sets the variants of Interrupters
 * @property {string} image - url src for the desktop image
 */
exports.Interrupters = Interrupters;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an object to the actionGroups prop
  */
  actionGroups: _propTypes.default.object,
  /**
  * Sets the background color for Interrupters
  */
  backgroundColor: _propTypes.default.string,
  /**
   * Sets the bodyCopy text
  */
  bodyCopy: _propTypes.default.string,
  /**
   * Sets the coupon details action
  */
  couponDetails: _propTypes.default.object,
  /**
   * Sets the primary action from an external source that contains business logic
  */
  externalAction: _propTypes.default.object,
  /**
   * Sets the external coupon action button object
  */
  externalCouponAction: _propTypes.default.object,
  /**
   * Sets the external media object
  */
  externalMedia: _propTypes.default.object,
  /**
   * Sets the headline text
   */
  headline: _propTypes.default.string,
  /**
    * Sets the tag to be used for headline
  */
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p']),
  /**
   * Sets the theme at component level
  */
  theme: _propTypes.default.string,
  /**
   * Sets the variant of the Interrupters
  */
  variant: _propTypes.default.oneOf(['smallImage', 'imageCopy', 'imageOnly', 'coupon', 'doubleWide']),
  /**
   * Sets the card header image
   */
  image: _propTypes.default.object
};

/**
 * Default values for passed properties
 * @type {object}
 * @property {string} variant - variant: 'smallImage' - sets the default for variant
 * @property {string} backgroundColor - backgroundColor: 'background-default' - sets the default background color
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default headline tag
 * @property {string} theme - theme: 'default' - sets the default theme
 */
const defaultProps = exports.defaultProps = {
  variant: 'smallImage',
  backgroundColor: 'background-default',
  headlineTag: 'h2',
  theme: 'default'
};
Interrupters.propTypes = propTypes;
var _default = exports.default = Interrupters;